import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18.98 8.544A14.927 14.927 0 0 0 17 16c0 8.286 6.715 15 15 15 2.654 0 5.206-.69 7.456-1.98.81-.466 1.76.336 1.435 1.213A18.003 18.003 0 0 1 24 42c-9.942 0-18-8.057-18-18 0-7.6 4.753-14.303 11.767-16.892.877-.323 1.679.626 1.214 1.436Z"
    }
  )
);
var SvgMoonFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MoonFilled_default = SvgMoonFilled;

export { MoonFilled_default as default };
